<template lang='pug'>
//- Events-Main
div(:class='$style[`cc-event`]')
  div(:class='$style[`cc-event-wrap`]')
    div(:class='$style[`cc-event-wrap-title`]')
      div(:class='$style[`cc-event-wrap-title-text`]')
        span.font-bold.font-doctor-theme 講
        span.font-bold.font-normal-theme 座
        span.font-bold 活動
        //- span.font-bold!= '列表'

    div(v-if='preloading' :class='$style[`cc-event-wrap-container`]')
      div(:class='$style[`cc-event-loading`]')
        IconLoading(:size='36' :color='`#b1b1b1`')

    div(v-else :class='$style[`cc-event-wrap-container`]')
      div(:class='$style[`cc-event-wrap-news`]')
        header.font-medium(:class='$style[`cc-event-wrap-news-head`]') 可報名的講座活動
        ul(:class='$style[`cc-event-wrap-news-ul`]')
          li(v-for='items, index in validList' :key='index' :class='$style[`cc-event-wrap-news-li`]')
            router-link(
              tabindex='0'
              aria-label='詳細資訊'
              :to='`/events/ev${startDateReplaceString(items.start_date)}`'
              :class='$style[`cc-event-news-content`]'
              :title='`${items.title}`')
              div(:class='$style[`cc-event-news-block`]')
                figure(:class='$style[`cc-event-news-thumb`]')
                  img(:src='`${SERVER_STATIC_URL}media/${items.photo_cover}`' width='100%')
                //- div.font-medium(:class='$style[`cc-event-news-origin`]') {{ `${items.organizer}主辦` }}
                div.font-medium(:class='$style[`cc-event-news-origin`]') Cancell 醫抗癌主辦
                  span(v-if='items.isEnd' :class='$style[`cc-event-news-origin-tip-end`]') 已結束
                  span(v-else :class='$style[`cc-event-news-origin-tip`]') 免費講座
                div.font-bold(:class='$style[`cc-event-news-title`]') {{ `${items.title}` }}
              div(v-if='items.isEnd' :class='$style[`cc-event-news-btn-end`]') 觀看回顧影片
              div(v-else :class='$style[`cc-event-news-btn`]') 立即報名

      div(:class='$style[`cc-event-wrap-news`]')
        header.font-medium(:class='$style[`cc-event-wrap-news-head`]') 過往講座活動 / 影片回顧
        ul(:class='$style[`cc-event-wrap-news-ul`]')
          li(v-for='items, index in endList' :key='index' :class='$style[`cc-event-wrap-news-li`]')
            router-link(
              role='button'
              tabindex='0'
              aria-label='詳細資訊'
              :to='`/events/ev${startDateReplaceString(items.start_date)}`'
              :class='$style[`cc-event-news-content`]'
              :title='`${items.title}`')
              div(:class='$style[`cc-event-news-block`]')
                figure(:class='$style[`cc-event-news-thumb`]')
                  img(:src='`${SERVER_STATIC_URL}media/${items.photo_cover}`' width='100%')
                div.font-medium(:class='$style[`cc-event-news-origin`]') Cancell 醫抗癌主辦
                  span(:class='$style[`cc-event-news-origin-tip-end`]') 已結束
                div.font-bold(:class='$style[`cc-event-news-title`]') {{ `${items.title}` }}
              div(:class='$style[`cc-event-news-btn-end`]') 觀看回顧影片

        //- LazyLoad
        infinite-loading(:identifier='infiniteId' @infinite='infiniteHandler')
          div(slot='spinner')
            IconLoading(
              slot='spinner'
              :size='30'
              :color='`#b1b1b1`')

          div.infinite-scroll-slot(slot='no-more' style='padding-top: 15px;')
            span.infinite-scroll-slot-noMore 沒有更多資料

          div.infinite-scroll-slot(slot='no-results' style='padding-top: 15px;')
            span.infinite-scroll-slot-noMore 沒有更多資料



</template>

<script>
import axios from 'axios';
import {
  putLectureList,
} from '../../../js/restapi';

import IconLoading from '../../icon/Loading';

export default {
  metaInfo() {
    return {
      title: '講座活動',
      titleTemplate: '%s | Cancell 醫抗癌',
      meta: [{
        name: 'og:url',
        content: 'https://cancell.tw/events',
      }],
      link: [{
        rel: 'canonical',
        href: 'https://cancell.tw/events',
      }],
    };
  },

  components: {
    IconLoading,
  },

  data() {
    return {
      preloading: true,
      pageSize: 10,
      pageIndex: 1,

      zumba: {
        title: "癌康網線上Zumba運動課",
        photo_cover: "lecture/banner/zumba.webp",
        start_date: "zumba",
        start_time: "19:50",
        ended: false
      },
      validList: [],
      endList: [],

      infiniteId: +new Date(),
    };
  },

  created() {
    this.axiosLoadAllLectureData();
  },

  methods: {
    infiniteHandler($state) {
      if (!this.preloading) {
        // const jwtAccess = JSON.parse(this.authJwtToken).a;
  
        putLectureList('', {
          page: this.pageIndex,
          size: this.pageSize,
          ended: true,
        })
          .then((res) => {
            res.data.results.map((x) => this.endList.push(x));
            console.log('LazyLoad Success', this.endList);

            if (res.data.results.length < this.pageSize || this.endList.length === res.data.count) {
              $state.complete();
            } else {
              this.pageIndex += 1;
            }
            $state.loaded();
          })
          .catch((err) => {
            console.log('讀取講座清單 Error', err);
          })
      } else {
        $state.complete();
      }
    },

    axiosLoadAllLectureData() {
      axios.all([
        putLectureList('', {
          page: 1,
          size: 20,
          ended: false,
        }, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          }
        }),
        putLectureList('', {
          page: this.pageIndex,
          size: this.pageSize,
          ended: true,
        }, {
          headers: {
            'content-Type': 'application/json',
            // Authorization: `Bearer ${jwtAccess}`,
          }
        })])
        .then(axios.spread((validData, endData) => {
          this.validList = validData.data.results;
          this.endList = endData.data.results;
          this.pageIndex += 1;
          this.preloading = false;
        }))
        .catch((error) => {
          console.log(`登入 Auth Step-3:: 分析帳號類型(${userType})並從DB撈取完整會員資料，Failed!`, error.response);
          this.preloading = false;
        })
    },

    startDateReplaceString(date) {
      let dateStr = '';
      if (date) {
        dateStr = date.replace(/\./g, '');
      } else {
        dateStr = date;
      }
      return dateStr;
    },
  }
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/event/event.scss';
</style>
